/* dynamic-layout-action-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dynamic-layout-action-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
var styles = {
  anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
  imageWrapper: "_2rko1qi0 _1reo15vq _18m915vq _1bsbckbl _4t3ickbl _1lrw1dfr _1itkhgf5",
  container: "_2rko12b0 _1bsbaq3k _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkysee _irr3wejn _d0altlke",
  summaryBox: "_p12f1wdt"
};
export var DynamicLayoutActionCard = function DynamicLayoutActionCard(_ref) {
  var _component$attributes, _component$attributes2, _component$attributes3;
  var component = _ref.component;
  var url = ((_component$attributes = component.attributes) === null || _component$attributes === void 0 ? void 0 : _component$attributes.url) || '';
  var title = ((_component$attributes2 = component.attributes) === null || _component$attributes2 === void 0 ? void 0 : _component$attributes2.title) || '';
  var text = ((_component$attributes3 = component.attributes) === null || _component$attributes3 === void 0 ? void 0 : _component$attributes3.text) || '';
  return title || text ? /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    xcss: styles.anchor,
    "aria-label": "",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.container),
    space: "space.200",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.imageWrapper
  }), /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, title && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    maxLines: 1
  }, title), text && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.summaryBox
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    size: "small",
    maxLines: 2
  }, text))))) : null;
};